import React, { useState, useEffect } from 'react';
import { Modal, Radio, Select, Checkbox } from 'antd';
// 使用 window.message 代替 antd 静态方法，避免 context 警告
import { EditOutlined } from '@ant-design/icons';
import { TRACK_OPTIONS, RECRUITING_STATUS_OPTIONS, MISSING_ROLES_OPTIONS } from '../../utils/constants';

const { Option } = Select;

/**
 * 标签编辑Modal组件
 * @param {Object} props - 组件属性
 * @param {boolean} props.visible - 是否显示Modal
 * @param {Function} props.onCancel - 取消回调
 * @param {Function} props.onOk - 确认回调
 * @param {Object} props.initialData - 初始数据
 * @returns {ReactElement} 标签编辑Modal组件
 */
const TagEditModal = ({ visible, onCancel, onOk, initialData = {} }) => {
  const [recruitingStatus, setRecruitingStatus] = useState('recruiting');
  const [scene, setScene] = useState('');
  const [missingRoles, setMissingRoles] = useState([]);
  const [loading, setLoading] = useState(false);

  // 初始化数据
  useEffect(() => {
    if (visible && initialData) {
      setRecruitingStatus(initialData.recruiting_status || 'recruiting');
      setScene(initialData.scene || '');
      setMissingRoles(initialData.missing_roles || []);
    }
  }, [visible, initialData]);

  // 处理确认
  const handleOk = async () => {
    if (!recruitingStatus) {
      window.message?.error('请选择组队状态');
      return;
    }

    setLoading(true);
    try {
      const result = {
        recruiting_status: recruitingStatus,
        scene: scene,
        missing_roles: missingRoles,
      };
      
      await onOk(result);
      window.message?.success('标签更新成功');
    } catch (error) {
      console.error('标签更新失败:', error);
      window.message?.error('标签更新失败');
    } finally {
      setLoading(false);
    }
  };

  // 处理取消
  const handleCancel = () => {
    setRecruitingStatus('recruiting');
    setScene('');
    setMissingRoles([]);
    onCancel();
  };

  return (
    <Modal
      open={visible}
      onCancel={handleCancel}
      onOk={handleOk}
      title={
        <div className="flex items-center gap-2">
          <EditOutlined className="text-blue-500" />
          <span className="text-lg font-medium">编辑团队标签</span>
        </div>
      }
      okText="保存"
      cancelText="取消"
      confirmLoading={loading}
      width={500}
      centered
    >
      <div className="py-4 space-y-6">
        {/* 组队状态 */}
        <div>
          <div className="text-sm font-medium text-gray-700 mb-3">
            组队状态 <span className="text-red-500">*</span>
          </div>
          <Radio.Group
            value={recruitingStatus}
            onChange={(e) => setRecruitingStatus(e.target.value)}
            className="w-full"
          >
            {RECRUITING_STATUS_OPTIONS.map((option) => (
              <Radio key={option.value} value={option.value} className="mb-2">
                {option.label}
              </Radio>
            ))}
          </Radio.Group>
        </div>

        {/* 场景 */}
        <div>
          <div className="text-sm font-medium text-gray-700 mb-3">
            场景
          </div>
          <Select
            value={scene}
            onChange={setScene}
            placeholder="请选择场景（可选）"
            allowClear
            className="w-full"
          >
            {TRACK_OPTIONS.map((option) => (
              <Option key={option} value={option}>
                {option}
              </Option>
            ))}
          </Select>
        </div>

        {/* 缺少角色 */}
        <div>
          <div className="text-sm font-medium text-gray-700 mb-3">
            缺少角色
          </div>
          <Checkbox.Group
            value={missingRoles}
            onChange={setMissingRoles}
            className="w-full"
          >
            {MISSING_ROLES_OPTIONS.map((option) => (
              <Checkbox key={option.value} value={option.value} className="mb-2">
                {option.label}
              </Checkbox>
            ))}
          </Checkbox.Group>
        </div>
      </div>
    </Modal>
  );
};

export default TagEditModal; 